import {
  Flex,
  Text,
  PDFViewer,
  DocumentViewer,
  XLSViewer,
} from '@/_components';
import { getExtensionOfFilename } from '@/_utils/files';
import type { DocumentRendererProps } from './DocumentRenderer.types';

export const DocumentRenderer: React.FC<DocumentRendererProps> = ({
  url,
  onPasswordRequest,
}) => {
  const extension = getExtensionOfFilename(url);

  const defaultPasswordRequest = async (): Promise<string> => {
    return globalThis.prompt('Enter password:') || '';
  };

  const handlePasswordRequest = onPasswordRequest || defaultPasswordRequest;

  switch (extension) {
    case 'pdf':
      return <PDFViewer url={url} onPassword={handlePasswordRequest} />;
    case 'xlsx':
    case 'xls':
      return <XLSViewer url={url} />;
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'heic':
    case 'avif':
      return <DocumentViewer url={url} />;
    default:
      return (
        <Flex isColumn isCentered gap={4} style={{ padding: '32px' }}>
          <Text color="secondary">File type not supported</Text>
        </Flex>
      );
  }
};
